import styled from "@emotion/styled";
import { fontBarlowSemiCondensed } from "@product/scmp-sdk";

import { EntityLink } from "~/components/entity-link";

export const StyledEntityLink = styled(EntityLink)``;

type CardLinkContainerProps = {
  $hasBottomBannerAd: boolean;
};

export const CardLinkContainer = styled.div<CardLinkContainerProps>`
  position: fixed;
  inset-block-end: ${props => (props.$hasBottomBannerAd ? "calc(100px + 16px + 16px)" : "16px")};
  z-index: 3;

  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: fit-content;
  margin-inline: auto;

  ${StyledEntityLink} {
    display: flex;
    justify-content: center;
    align-items: center;

    inline-size: 108px;
    block-size: 33px;

    color: #222222;
    font-weight: 600;
    font-size: 14px;
    font-family: ${fontBarlowSemiCondensed};
    font-style: normal;
    line-height: 17px;
    letter-spacing: 0.1em;
    text-align: center;
    text-transform: uppercase;

    border: 1px solid #ffffff;
    border-radius: 2px;

    background: #ffffff;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    position: absolute;
    inset-block-end: ${props => (props.$hasBottomBannerAd ? "140px" : "32px")};
  }
`;
